import { StatusCadastroEnum } from "../enum";

export class CRMCanalVenda {
    id: number;
    descricao: string;
    statusCadastro: StatusCadastroEnum = StatusCadastroEnum.Ativo;
}